import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

// Animates a numeric prefix from 0 -> target when scrolled into view.
// Keeps any suffix (e.g. "12K+", "24/7", "400+").
export const CountUp = ({ value, duration = 1600, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(() => {
    const m = String(value).match(/^(\d+)(.*)$/);
    return m ? `0${m[2]}` : String(value);
  });

  useEffect(() => {
    const m = String(value).match(/^(\d+)(.*)$/);
    if (!inView || !m) { if (!m) setDisplay(String(value)); return; }
    const target = parseInt(m[1], 10);
    const suffix = m[2];
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(`${Math.round(eased * target)}${suffix}`);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value, duration]);

  return <span ref={ref} className={className} data-testid="count-up">{display}</span>;
};
